/* AutoCart → Minimog. La app controla elegibilidad, regalos y descuentos.
 * El tema refresca las secciones de Shopify sin recargar la página.
 * marker es opcional y sólo se usa en enlaces internos de pruebas.
 */
(() => {
  const configNode = document.getElementById('mz-autocart-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = config.root.endsWith('/') ? config.root : `${config.root}/`;
  const html = document.documentElement;
  html.dataset.mzAutocartPage = crypto.randomUUID();
  let renderTimer;
  let rendering = false;
  let renderAgain = false;
  let activating = false;

  function status(message, state) {
    html.dataset.mzAutocartState = state;
    document.querySelectorAll('[data-mz-autocart-status]').forEach(node => {
      node.textContent = message;
    });
  }

  async function json(url, options) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
    return response.json();
  }

  function scheduleRender() {
    clearTimeout(renderTimer);
    // Let the theme finish rendering its original add/change response first.
    renderTimer = setTimeout(refreshSections, 150);
  }

  async function refreshSections() {
    if (rendering) { renderAgain = true; return; }
    rendering = true;
    try {
      const names = ['cart-count'];
      if (document.getElementById('MinimogCart')) names.push('cart-template');
      if (document.getElementById('MinimogCartDrawer')) names.push('cart-drawer');
      const sections = await json(`${root}?sections=${names.join(',')}`);
      const parser = new DOMParser();
      const parsed = {};
      // Validate every section before replacing anything.
      names.forEach(name => {
        if (typeof sections[name] !== 'string') throw new Error(`Missing ${name}`);
        parsed[name] = parser.parseFromString(sections[name], 'text/html');
      });
      const focused = document.activeElement;
      const focusId = focused?.id;
      const pageCart = document.getElementById('MinimogCart');
      if (pageCart) {
        const fresh = parsed['cart-template'].getElementById('MinimogCart');
        if (!fresh) throw new Error('Missing cart markup');
        const body = pageCart.querySelector('#MinimogCartBody');
        const freshBody = fresh.querySelector('#MinimogCartBody');
        if (body && freshBody) {
          // Preserve the theme's custom element instances and their listeners.
          ['#MinimogCartBody', '#MinimogCartFooter', '.m-cart-mz__header',
            '.m-cart-mz__shipping-bar', '.m-cart-mz__delivery'].forEach(selector => {
            const current = pageCart.querySelector(selector);
            const next = fresh.querySelector(selector);
            if (current && next) current.innerHTML = next.innerHTML;
          });
        } else {
          // Empty carts have no quantity controls; render their empty-state layout.
          pageCart.innerHTML = fresh.innerHTML;
        }
      }
      const drawer = parsed['cart-drawer'];
      if (drawer) {
        ['MinimogCartDrawerHeader', 'MinimogCartDrawerBody', 'MinimogCartDrawerFooter'].forEach(id => {
          const current = document.getElementById(id);
          const fresh = drawer.getElementById(id);
          if (current && fresh) {
            current.innerHTML = fresh.innerHTML;
            if (fresh.hasAttribute('data-mz-empty')) current.dataset.mzEmpty = fresh.dataset.mzEmpty;
          }
        });
      }
      const count = parsed['cart-count'].querySelector('m-cart-count');
      if (count) {
        document.querySelectorAll('m-cart-count').forEach(node => {
          node.textContent = count.textContent;
          node.classList.toggle('m:hidden', Number(count.textContent.trim()) === 0);
        });
        document.querySelectorAll('.m-cart-icon-bubble').forEach(node => {
          node.setAttribute('aria-label', count.textContent.trim());
        });
      }
      if (focusId && !focused.isConnected) document.getElementById(focusId)?.focus({ preventScroll: true });
      html.dataset.mzAutocartRenders = String(Number(html.dataset.mzAutocartRenders || 0) + 1);
      status('Tu carrito está actualizado.', 'ready');
    } catch (error) {
      status('No pudimos actualizar el carrito. Vuelve a abrirlo antes de pagar.', 'error');
      console.error('[Mizuno AutoCart] Cart display could not be refreshed', error);
    } finally {
      rendering = false;
      if (renderAgain) { renderAgain = false; scheduleRender(); }
    }
  }

  async function activatePreview() {
    if (activating) return;
    activating = true;
    try {
      const cart = config.marker ? await json(`${root}cart.js`) : null;
      if (config.marker && cart.attributes?.mz_belt_qa !== config.marker) {
        await json(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { mz_belt_qa: config.marker } })
        });
      }
      status('Tu carrito está actualizado.', 'ready');
      document.dispatchEvent(new Event('handle-autocart'));
      if (document.getElementById('MinimogCart')) scheduleRender();
    } catch (error) {
      status('No pudimos actualizar la promoción. Vuelve a abrir el carrito.', 'error');
      console.error('[Mizuno AutoCart] Preview activation failed', error);
    } finally { activating = false; }
  }

  document.addEventListener('autocart:updated', event => {
    if (event.detail?.type !== 'noop' || event.detail?.changes?.length) scheduleRender();
  });
  document.addEventListener('mz:gift-repaired', scheduleRender);
  document.addEventListener('autocart:error', () => {
    status('No pudimos actualizar el regalo. Revisa tu carrito antes de pagar.', 'error');
  });
  // An app loaded after our activation still needs one evaluation with fresh data.
  document.addEventListener('autocart:ready', () => {
    if (html.dataset.mzAutocartState === 'ready') document.dispatchEvent(new Event('handle-autocart'));
  }, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', activatePreview, { once: true });
  else activatePreview();
  window.addEventListener('pageshow', event => { if (event.persisted) activatePreview(); });
})();
